<template>
  <Dialog
    class="container-dialog"
    v-if="errosAxios.erroAxios"
    v-model:visible="errosAxios.erroAxios"
    :header="errosAxios.header ? errosAxios.header : 'Erro!'"
    modal
    id="dialogErroAxios"
  >
    <div class="conteudo-dialog">
      <i :class="errosAxios.icon"></i>
      <span>{{ errosAxios.mensagemErroAxios }}</span>
    </div>
    <Button class="w-full mt-5" label="Fechar" @click="fechaErroAxios" />
  </Dialog>
</template>

<script>
import { errosAxios } from "@/store/store.js";

export default {
  data() {
    return {
      errosAxios,
    };
  },
  methods: {
    fechaErroAxios() {
      errosAxios.erroAxios = false;
    },
  },
};
</script>
